import { render, staticRenderFns } from "./ContentPoint.vue?vue&type=template&id=e9bfc5f2&scoped=true&"
import script from "./ContentPoint.vue?vue&type=script&lang=js&"
export * from "./ContentPoint.vue?vue&type=script&lang=js&"
import style0 from "./ContentPoint.vue?vue&type=style&index=0&id=e9bfc5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bfc5f2",
  null
  
)

export default component.exports